import { configureStore } from "@reduxjs/toolkit";
import CIFReducer from "../Reducer/CIFReducer";
import DDUReducer from "../Reducer/DDUReducer";
import FOBReducer from "../Reducer/FOBReducer";
import EXWReducer from "../Reducer/EXWReducer";
import CityAndPortReducer from "../Reducer/CityAndPortReducer";
import DDPReducer from "../Reducer/DDPReducer";
import OceanInsuranceReducer from "../Reducer/Insurance";
import updateCIFValue from "../Reducer/CIFUpdateReducer";
import currencyListReducer from "../Reducer/CurrencyList";
import selectedCurrencyReducer from "../Reducer/CurrencyReducer";
import dashBoardDataReducer from "../Reducer/DashboardReducer";

const store = configureStore({
  reducer: {
    CIFData: CIFReducer,
    DDUData: DDUReducer,
    DDPData: DDPReducer,
    FOBData: FOBReducer,
    EXWData: EXWReducer,
    DropDownData: CityAndPortReducer,
    CIFValue: updateCIFValue,
    OceanInsurance: OceanInsuranceReducer,
    Currency: currencyListReducer,
    SelectedCurrency: selectedCurrencyReducer,
    dashboardData: dashBoardDataReducer,
  },
});

export default store;
